import SvgAlert from '@/assets/icons/Alert';
import { stationConflict } from '@/components/detailPanel/types/types';

export const getConflictIcon = (conflicts?: stationConflict[]) => {
  if (!conflicts?.length) return null;

  const hasPerronlengte = conflicts.some((c) => c.type === 'PERRONLENGTE');
  if (hasPerronlengte) {
    return <SvgAlert fill='var(--tractie-color-content-warning)' style={{ width: 20, height: 20, marginTop: -6 }} />;
  }

  return null;
};
